// extracted by css-extract-rspack-plugin
export default {"cls1":"BottomSection-cls1_BNl","cls2":"BottomSection-cls2_kXp BottomSection-cls1_BNl"};